<template>
  <div class="app-container" style="padding: 0;">
    <div style="display: flex;justify-content: center;min-width: calc(1280px - 210px - 6px);">
      <iframe :id="elementId" style="width: 100%;height: 100vh;border: none" :src="baseUrl + '?code=' + code + '&t=' + (new Date()).getTime()" />
    </div>
    <div class="fixedBtn" @click="drawer = true">
      <i class="el-icon-arrow-left" />
    </div>
    <el-drawer
        title="样例列表"
        :visible.sync="drawer"
        direction="rtl"
        :size="200"
        :show-close="false"
    >
      <div>
        <div v-for="(v,k) in sampleList" :key="k">
          <el-link style="margin-left: 10px;margin-bottom: 10px" :underline="false" @click="toSample(v.code)">{{ v.name }}</el-link>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'pythonOnline',
  data() {
    return {
      baseUrl: 'https://pyeditor.kjt61.com/',
      code: 'lbx',
      drawer: false,
      sampleList: [
        {
          name: '样例-小猪佩琪',
          code: 'pinkpig'
        },
        {
          name: '样例-彩色螺旋线',
          code: 'colorspiral'
        },
        {
          name: '样例-樱花树',
          code: 'sakuratree'
        }
      ],
      elementId: 'py-editor' + this.randomString(8)
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        if (this.$route.query.code) { // 需要监听的参数
          this.code = this.$route.query.code
        }
      }
    }
  },
  created() {
  },
  destroyed() {
    this.removeIframe()
  },
  methods: {
    toSample(code) {
      this.$router.push({ path: 'python-online', query: { code: code }})
      this.drawer = false
    },
    removeIframe() {
      var iframe = document.getElementById(this.elementId)

      // 把iframe指向空白页面，这样能够释放大部份内存。
      iframe.src = 'about:blank'

      try {
        iframe.contentWindow.document.write('')
        iframe.contentWindow.document.clear()
      } catch (e) {
        console.log(e)
      }

      // 把iframe从页面移除
      iframe.parentNode.removeChild(iframe)
    },
    randomString(e) {
      e = e || 32
      const t = '12345678'
      const a = t.length
      let n = ''
      for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a))
      return n
    }
  }
}
</script>

<style scoped>
.fixedBtn{
  width: 30px;
  position: absolute;
  right: 0;
  top: 40%;
  text-align: center;
  height: 50px;
  line-height: 50px;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 5px 0 0 5px;
  color: white;
  display: none;
}
</style>
